import type { MqttContainer, MqttValue } from './types'
import { MqttTopic } from './topics'

export const heartRate: MqttValue = {
  title: 'heart rate',
  unit: 'bpm',
  topic: MqttTopic.HEARTRATE_HEART_RATE,
}
export const rrTime: MqttValue = {
  title: 'rr time',
  unit: 'ms',
  topic: MqttTopic.HEARTRATE_RR_TIME,
}
export const accumulatedEventTime: MqttValue = {
  title: 'accumulated event time',
  unit: 'seconds',
  topic: MqttTopic.HEARTRATE_ACCUMULATED_EVENTTIME,
}
export const heartRateDefinitions: MqttContainer = {
  title: 'Heart rate',
  prefix: 'heartrate/',
  values: [
    heartRate,
    // rrTime,
    // accumulatedEventTime,
  ],
}
export default heartRateDefinitions
